import type {ThemeConfig} from 'antd/es/config-provider/context';

const colors = {
  primary: '#191919',
  secondary: '#3B3D49',
  border: '#BABABA',

  // colors MP 2.0
  'bg-input': '#E0E3ED',

  // Filter Experiences colors
  filterBg: '#392f99',
  filterText: '#FFFFFF',
  filterTextPlaceholder: 'rgba(255, 255, 255, 0.4)',
};

const AntdThemeConfig: ThemeConfig = {
  token: {
    colorText: colors.primary,
    borderRadius: 0,
    fontFamily: 'var(--font-primary)',
    colorBorder: colors.border,
    colorTextHeading: 'inherit',
    colorTextLabel: colors.secondary,
    colorLink: 'inherit',
    colorLinkHover: 'inherit',
    colorLinkActive: 'inherit',
    fontSize: 16,
    fontSizeSM: 14,
    fontSizeLG: 18,

    // Custom colors for FilterExperiences
    colorBgContainer: colors.filterBg,
    colorTextPlaceholder: colors.filterTextPlaceholder,
    colorTextBase: colors.filterText,
  },
  components: {
    Select: {
      colorBgContainer: colors.filterBg,
      colorTextPlaceholder: colors.filterTextPlaceholder,
      colorText: colors.filterText,
      borderRadius: 8,
      controlHeight: 55,
      paddingContentHorizontal: 20,
      paddingContentVertical: 15,
    },
    // Input: {

    // },
  },
};

export default AntdThemeConfig;
